import locales from "i18n/staticLocales";
import {type AvailableLocale} from "i18n/translations";
import config from "config/config";

// Workspace-local copy of the monolith's LookupTranslations: same locale-matching logic,
// but reads the fallback locale from the workspace config (the monolith read it from
// webview/config, which isn't bundler-portable). The locale data itself is the shared
// monolith source via the i18n/staticLocales alias.
const defaultLocale = config.defaultLocale;

interface AvailableLanguages {
    [key: string]: AvailableLocale[];
}

// { "en": ["en-gb", ...], ... }
const availableTranslations = ((): AvailableLanguages => {
    const translationsArray: AvailableLanguages = {};

    Object.keys(locales).forEach((locale) => {
        const language = locale.substring(0, 2);
        if (!translationsArray[language]) {
            translationsArray[language] = [];
        }
        translationsArray[language]?.push(locale as AvailableLocale);
    });
    return translationsArray;
})();

export const resolveLocale = (userLocale: string): AvailableLocale => {
    const locale = (userLocale || defaultLocale).toLowerCase();
    const [language] = locale.split("-");
    if (!language) {
        return defaultLocale;
    }

    const languageTranslationLocales = availableTranslations[language];
    if (!languageTranslationLocales) {
        return defaultLocale;
    }

    if (languageTranslationLocales.includes(locale as AvailableLocale)) {
        return locale as AvailableLocale;
    }

    if (language === "en") {
        return defaultLocale;
    }

    return languageTranslationLocales[0] ?? defaultLocale;
};

export default function lookupTranslations(locale: string) {
    return locales[resolveLocale(locale)];
}
